<!--
 * @Author: dengyong simon.deng@wetax.com.cn
 * @Date: 2022-06-14 17:00:48
 * @LastEditors: yangyi
 * @LastEditTime: 2022-11-18 11:51:52
 * @FilePath: \tiangong2\src\views\sysmana\application\components\accessForm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="accessForm">
    <ul>
      <li>
        <b>{{ accessForm.accessType === 1 ? '聚合' : '移动' }}应用ID：</b>{{ accessForm.mgameId }}
      </li>
      <li><b>KEY：</b>{{ accessForm.gameKey }}</li>
      <li><b>SECRET：</b>{{ accessForm.gameSecret }}</li>
    </ul>
    <el-radio-group v-model="tabName">
      <el-radio-button label="SDK">SDK</el-radio-button>
      <el-radio-button label="API">API</el-radio-button>
    </el-radio-group>
    <div class="iframe" v-if="tabName === 'SDK'">
      <iframe src="https://docs.qq.com/doc/DY3FXZkVaVGpRaWRL" width="100%" height="100%" frameborder="0"></iframe>
    </div>
    <div class="iframe" v-if="tabName === 'API'">
      <iframe src="https://shimo.im/docs/lDSuvSyq6jw59mzL/" width="100%" height="100%" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'accessForm',
  props: ['accessForm'],
  data() {
    return {
      tabName: 'SDK'
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.accessForm {
  ul {
    padding-bottom: 20px;
    li {
      display: inline-block;
      margin-right: 20px;
      font-size: 16px;
    }
    li:last-child {
      margin-right: 0;
    }
  }
}
.iframe {
  height: calc(100vh - 360px);
}
</style>
